import { render, staticRenderFns } from "./AlertMesage.vue?vue&type=template&id=13e4489a&scoped=true&"
import script from "./AlertMesage.vue?vue&type=script&lang=js&"
export * from "./AlertMesage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4489a",
  null
  
)

export default component.exports